import { render, staticRenderFns } from "./MonsterChapter.vue?vue&type=template&id=378de16d&lang=pug&"
import script from "./MonsterChapter.vue?vue&type=script&lang=ts&"
export * from "./MonsterChapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports